
import React from 'react';
import { Star, Award, ThumbsUp, Sparkles } from 'lucide-react';

export interface IconOption {
  name: string;
  component: React.ReactNode;
}

export const AVAILABLE_ICONS: IconOption[] = [
  { name: 'star', component: <Star className="h-5 w-5" /> },
  { name: 'award', component: <Award className="h-5 w-5" /> },
  { name: 'thumbs-up', component: <ThumbsUp className="h-5 w-5" /> },
  { name: 'sparkles', component: <Sparkles className="h-5 w-5" /> },
];

interface BenefitIconsProps {
  selectedIcon: string;
  onSelectIcon: (iconName: string) => void;
}

export const BenefitIcons = ({ selectedIcon, onSelectIcon }: BenefitIconsProps) => {
  return (
    <div className="flex space-x-2">
      {AVAILABLE_ICONS.map((icon) => (
        <button
          key={icon.name}
          type="button"
          className={`p-2 rounded-md ${
            selectedIcon === icon.name
              ? "bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"
              : "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300"
          }`}
          onClick={() => onSelectIcon(icon.name)}
          title={icon.name}
        >
          {icon.component}
        </button>
      ))}
    </div>
  );
};

export const getIconComponent = (iconName: string) => {
  const icon = AVAILABLE_ICONS.find((i) => i.name === iconName);
  return icon ? icon.component : AVAILABLE_ICONS[0].component;
};
